import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'

import { reducer as form } from 'redux-form'
import { ModalReducer as modal } from '../components/ModalRedux'
import { PopupReducer as popup } from '../components/PopupRedux'
import { SystemErrorReducer as systemError } from '../components/SystemErrorRedux'

import mainReducks from '../reducks'
import * as initialStateReducers from '../reducks/initialState'
import sessionReducks from '../reducks/sessions'
import profileReducks from '../../Profile/reducks'
import interviewRequestReducks from '../../InterviewRequests/redux/modules'
import dashboardReducer from '../../Dashboard/redux/modules'
import onboardingReducks from '../../Onboarding/redux/modules'

import { createReduxHistoryContext } from 'redux-first-history'
import browserHistory from './browserHistory'

export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: browserHistory,
})

const configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware()

  const middleware = () => {
    if (process.env.NODE_ENV === 'development') {
      const { composeWithDevTools } = require('@redux-devtools/extension')
      const { createLogger } = require('redux-logger')

      const composeEnhancers = composeWithDevTools({ trace: true })
      if (process.env.REACT_APP_DISABLE_REDUX_LOGGING === 'true') {
        return composeEnhancers(applyMiddleware(routerMiddleware, sagaMiddleware))
      }
      return composeEnhancers(applyMiddleware(routerMiddleware, sagaMiddleware, createLogger()))
    }

    return applyMiddleware(routerMiddleware, sagaMiddleware)
  }

  const rootReducer = combineReducers({
    router: routerReducer,
    form,
    modal,
    popup,
    systemError,
    entities: combineReducers(mainReducks),
    views: combineReducers({
      ...profileReducks,
      interviewRequests: interviewRequestReducks,
      sessions: sessionReducks,
    }),
    static_data: initialStateReducers.staticDataReducer,
    currentUser: initialStateReducers.currentUserReducer,
    dashboard_state: dashboardReducer,
    ...onboardingReducks,
  })

  const store = createStore(rootReducer, initialState, compose(middleware()))

  store.registerSaga = (name, saga) => {
    sagaMiddleware.run(saga)
  }

  return store
}

export default configureStore
